
















import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import BaseSelect from "../form/baseSelect.vue";

@Component({
  components: { BaseSelect },
})
export default class ListingTopPanel extends Vue {
  @Prop({ type: String, required: true }) label!: string;
  @Prop({ type: Array, required: true }) options!: any[];
  @Prop({ required: true }) value!: any;
  @Prop({ type: String, default: "domSort" }) selectId!: string;

  handleChange(value: string) {
    this.$emit("input", value);
    this.$emit("change", value);
  }
}
